module.exports = __webpack_public_path__ + "img/level-3-stand.bfcdca07.svg";